import Loading01 from "@untitled-ui/icons-react/build/esm/Loading01";
import styled from "styled-components";

const StyledLoadingSpinner = styled.div`
    & {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }

    .loading-spinner {
        animation: spin 1.5s linear infinite;
    }
`;

/** A simple loading spinner component.
 * @param {string} color - Color of the spinner
 * @param {string} width - Width of the spinner
 * @param {string} height - Height of the spinner
 * @param {object} style - Additional styles
 * @param {string} className - Additional class names
 * @returns {JSX.Element}
 */
export default function SimpleLoadingSpinner({
    color = "#00BB00",
    width = "15px",
    height = "15px",
    style = {},
    className = ""
}) {
    return (
        <StyledLoadingSpinner className={className} style={style}>
            <Loading01
                className="loading-spinner"
                color={color}
                width={width}
                height={height}
                style={{
                    position: "relative",
                    top: "1px"
                }}
            />
        </StyledLoadingSpinner>
    );
}
